<template>
    <div v-text-align.center>
        <v-spinner />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { enter } from '../../services/api/account';

    export default {
        name: 'sign-profile',
        methods: {
            ...mapActions(['error']),
        },
        mounted() {
            enter(this.$route.query)
                .then((res) => {
                    this.$router.push('/');
                })
                .catch((res) => {
                    this.error(res);
                });
        }
    }
</script>


// WEBPACK FOOTER //
// ForceLogin.vue?7f0f7dd8